<template>
    <div class="post-listing-wrapper">
        <infinite-scroller-vertical @scrolledTillBottom="onReachScrollBottom">
            <v-container fluid>
                <v-row dense>
                    <v-col v-for="(post) in posts" :key="`profile-saved-post-${post.id}`" cols="6" md="4">
                        <v-card v-if="post.attachments" tile flat :to="`/post/${post.id}/`" :color="post.attachments.length ? 'grey' : 'primary'">
                            <v-img v-if="post.attachments.length" :src="post.attachments[0].file_url" :lazy-src="post.attachments[0].thumbnail_file_url" :aspect-ratio="1">
                                <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                            <v-card-title v-else v-html="post.title" class="justify-center"></v-card-title>
                        </v-card>
                        <v-card v-else>
                            <v-card-title v-html="post.title" class="justify-center"></v-card-title>
                        </v-card>
                    </v-col>
                    <template dense v-if="postListLoading">
                        <v-col class="d-flex" v-for="(n, i) in 3" :key="`photo-skel-loading-${i}`" cols="6" md="4">
                            <v-skeleton-loader type="image" width="100%" class="d-flex" tile></v-skeleton-loader>
                        </v-col>
                    </template>
                </v-row>
            </v-container>
            <v-container fluid v-if="!postListLoading && posts.length===0">
                <v-col cols="12">
                    <p class="headline font-weight-light text-center">No Saved Post!</p>
                </v-col>
            </v-container>
        </infinite-scroller-vertical>
    </div>
</template>
<script>
import {
    GET_PROFILE_SAVED_POST_LIST
} from "@/store/actions.type"
export default {
    created() {
        
        if (this.posts.length === 0) {
            this.fetchSavedPost()
        }
    },
    data: () => ({

    }),

    methods: {

        fetchSavedPost() {
            if (!this.$store.state.profile.profileSavedPostFetchCompleted && !this.postListLoading) {
                this.$store.dispatch(GET_PROFILE_SAVED_POST_LIST)
            }
        },

        onReachScrollBottom(val) {
            if (val) {
                this.fetchSavedPost()
            }
        }
    },

    destroyed() {},

    computed: {
        posts() {
            return this.$store.state.profile.profileSavedPostList
        },

        postListLoading() {
            return this.$store.state.profile.profileSavedPostListLoading
        }
    }


}
</script>